import { Field } from 'formik';

import { Add, Less } from '@/icons';
import { InputAtom } from '@/atoms/input/Input';

import styles from './number.module.css';

import type { FieldProps } from 'formik';
import type { FunctionComponent } from 'react';
import type { InputProps } from '../types';

/**
 * Primary UI component for user interaction
 */
export const NumberInput: FunctionComponent<InputProps> = ({
  className = '',
  name,
  /* eslint-disable-next-line @typescript-eslint/no-empty-function */
  onChange = () => {},
  error,
  disabled,
}: InputProps) => (
  <div className={styles['o-number']}>
    <Field name={name}>
      {({ field }: FieldProps) => (
        <div className={styles['o-number__wrapper']}>
          <div
            className={`\
              ${styles['o-number__less']} \
              ${disabled && styles['o-number__less--disabled']}\
            `}
            onClick={() => {
              if (!disabled) onChange(parseInt(field.value) - 1);
            }}
            data-playwright="cartLine-less"
            aria-disabled={disabled}
          >
            <Less />
          </div>

          <InputAtom
            hidden={true}
            field={field}
            name={name}
            type="number"
            error={error}
            value={field.value}
            className={`\
              ${styles['o-number__field']} \
              ${error ? styles['o-number__field--error'] : ''} \
              ${className}\
            `}
            // TODO: Añadir tipos
            checked
            handleBlur={field.onBlur}
            handleChange={field.onChange}
            data-playwright="cartLine-value"
          />

          <div
            className={`\
              \ border border-primary-200 pt-[3px]
              ${styles['o-number__field']} \
              ${error ? styles['o-number__field--error'] : ''} \
              ${className}\
            `}
          >
            {field.value}
          </div>

          <div
            onClick={() => {
              if (!disabled) onChange(parseInt(field.value) + 1);
            }}
            className={`\
              ${styles['o-number__more']} \
              ${disabled && styles['o-number__more--disabled']}\
            `}
            data-playwright="cartLine-add"
            aria-disabled={disabled}
          >
            <Add />
          </div>
        </div>
      )}
    </Field>

    {error && <p className={styles['o-number__errorMessage']}>{error}</p>}
  </div>
);
